module.exports = __webpack_public_path__ + "img/market_64fd9.png";